export const dimension = 'campaign';

export default {};
